import { render } from "./course-two.vue?vue&type=template&id=230a95cc"
import script from "./course-two.vue?vue&type=script&lang=js"
export * from "./course-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__